import { getPayPalTriplePointsEarnKeyMarker } from 'checkout/selectors/loyalty/pointsCalculation/earnKey/getPayPalTriplePointsCampaignConfig'
import { createSelector } from 'reselect'

const getCheckoutLoyaltyEarnKeyMarkers = createSelector(
  (state: App.State) => getPayPalTriplePointsEarnKeyMarker(state),
  // Insert other checkout-wide earn key marker resolvers here
  (payPalTriplePointsMarker): Array<string> => {
    if (!payPalTriplePointsMarker) return []

    return [payPalTriplePointsMarker]
  },
)

export default getCheckoutLoyaltyEarnKeyMarkers
